import React from 'react';

function HelpIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_287_601)">
        <g clipPath="url(#clip1_287_601)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0ZM8.5 14.7692C6.70469 14.7692 4.98291 14.056 3.71343 12.7866C2.44395 11.5171 1.73077 9.79531 1.73077 8C1.73077 6.20469 2.44395 4.48291 3.71343 3.21343C4.98291 1.94395 6.70469 1.23077 8.5 1.23077C10.2953 1.23077 12.0171 1.94395 13.2866 3.21343C14.556 4.48291 15.2692 6.20469 15.2692 8C15.2692 9.79531 14.556 11.5171 13.2866 12.7866C12.0171 14.056 10.2953 14.7692 8.5 14.7692ZM10.4077 4.40615C10.1951 4.18474 9.93963 4.00887 9.65692 3.88923C9.30123 3.74682 8.91986 3.67976 8.53692 3.69231C8.16524 3.68556 7.79627 3.75684 7.45385 3.90154C7.15969 4.02462 6.9 4.21415 6.69077 4.45538C6.48695 4.67707 6.32811 4.93623 6.22308 5.21846C6.12543 5.50516 6.06342 5.80278 6.03846 6.10462H7.55231C7.55928 5.90928 7.62149 5.71991 7.73172 5.5585C7.84195 5.39708 7.99568 5.27021 8.17508 5.19262C8.29399 5.14577 8.42162 5.12519 8.54923 5.13231C8.65931 5.11481 8.77146 5.11481 8.88154 5.13231C8.98266 5.17055 9.07483 5.22921 9.15231 5.30462C9.23781 5.3786 9.30519 5.47124 9.34923 5.57539C9.39965 5.69186 9.42482 5.8177 9.42308 5.94462C9.42308 6.15754 9.37754 6.36677 9.28769 6.56C9.1983 6.76048 9.08685 6.95037 8.95539 7.12615L8.52462 7.64308C8.37692 7.80308 8.22923 7.97538 8.09385 8.14769C7.96257 8.3192 7.8511 8.505 7.76154 8.70154C7.67615 8.89525 7.63415 9.10528 7.63846 9.31692V10.1292H9.11539V9.52615C9.11956 9.34564 9.16592 9.16861 9.25077 9.00923C9.35192 8.83205 9.46716 8.66331 9.59539 8.50462L10.0385 7.96308C10.1998 7.77674 10.3478 7.57933 10.4815 7.37231C10.623 7.16121 10.7387 6.93395 10.8262 6.69538C10.9159 6.44247 10.9617 6.17606 10.9615 5.90769C10.9637 5.62809 10.9222 5.34986 10.8385 5.08308C10.7455 4.82894 10.5986 4.59798 10.4077 4.40615ZM7.63846 10.8677H9.07846V12.3077H7.63846V10.8677Z"
            fill="#131B23"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_287_601">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
        <clipPath id="clip1_287_601">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HelpIcon;
